import React from 'react';
import BaseTag from 'components/atoms/base-tag';
import { useTranslation } from 'react-i18next';
import COLORS from 'assets/styles/colors';
import { DateFormats, DeviceStatus, Roles } from 'infrastructure/enums';
import { DateFormatter } from 'infrastructure/functions';
import useUser from 'utils/useUser';

import s from './styles.module.scss';

import type { PatientDevice } from 'infrastructure/classes/patient/patient-device';

interface IDeviceInformationProps {
  data: PatientDevice;
}

const DeviceInformation: React.FC<IDeviceInformationProps> = (props) => {
  const { data } = props;

  const { t } = useTranslation();
  const user = useUser();

  const TELLIHEALTH_LINK = process.env.REACT_APP_TELLIHEALTH_LINK;
  const deviceLink = `${TELLIHEALTH_LINK}${data.deviceId}`;

  const canShowLink =
    Boolean(TELLIHEALTH_LINK) &&
    (user.isAgencyDoctor || user.isAdmin) &&
    user.hasAnyRole([
      Roles.Administrator,
      Roles.Support,
      Roles.Onboarding,
      Roles.Biller,
      Roles.Default,
      Roles.Clinical,
      Roles.PatientAcceptance,
      Roles.CcmBiller,
    ]);

  return (
    <div className={s['device-info']} data-cy="device-table-device-info">
      <b>{data.manufacturer}</b> <br />
      {canShowLink ? (
        <a href={deviceLink} target="__blank" className={s.device}>
          {t('labels.id')}: {data.deviceId}
        </a>
      ) : (
        <label className={s.label}>
          {t('labels.id')}: {data.deviceId}
        </label>
      )}
      {data.createdAt && (
        <>
          <br />
          <label className={s.label}>
            {t('labels.deviceAdded')}:{' '}
            {DateFormatter({
              date: data.createdAt,
              format: DateFormats['MM-dd-yyyy'],
            })}
          </label>
        </>
      )}
      <div className={s.tags}>
        {data.status === DeviceStatus.Active ? (
          <BaseTag
            width="72px"
            color={COLORS.RANGE_LAND}
            label={t('labels.active')}
          />
        ) : (
          <BaseTag
            width="72px"
            color={COLORS.USUBENI_RED}
            label={t('labels.inactive')}
          />
        )}
        <BaseTag label={`${t('labels.gen')}-${data.generation}`} />
      </div>
    </div>
  );
};

export default DeviceInformation;
